export default class LocalStorageAdapter {
  getItem (key) {
    return Promise.resolve(
      window.localStorage.getItem(key)
    )
  }

  setItem (key, value) {
    return Promise.resolve(
      window.localStorage.setItem(key, value)
    )
  }

  removeItem (key, value) {
    return Promise.resolve(
      window.localStorage.removeItem(key, value)
    )
  }
}
